// import AplusContent from "./components/AplusContent.vue";
//
// export function createApp() {
//     Vue.component( "aplus-content", AplusContent );
// }

import reviewWidget from "./components/reviewWidget.vue";
import compareList from "./components/compareList.vue";

export function createApp() {
    Vue.component( "review-widget", reviewWidget );
    Vue.component( "compare-list", compareList );
}
